import CustomEndorsement from "./CustomEndorsement";
import PreSoloOne from "./PreSoloOne";
import PreSoloTwo from "./PreSoloTwo";
import PreSoloThree from "./PreSoloThree";
import SoloFlightOne from "./SoloFlightOne";
import SoloFlightTwo from "./SoloFlightTwo";
import SoloFlightThree from "./SoloFlightThree";
import SoloFlightFour from "./SoloFlightFour";
import SoloFlightFive from "./SoloFlightFive";
import EndorsementOfUs from "./EndorsementOfUs";
import SoloCrossCountryOne from "./SoloCrossCountryOne";
import RepeatedSoloCrossCountry from "./RepeatedSoloCrossCountry";
import SoloCrossCountryTwo from "./SoloCrossCountryTwo";
import AeronauticalKnowledge from "./AeronauticalKnowledge";
import ReviewOfDeficiencies from "./ReviewOfDeficiencies";
import PrerequisitesForPractical from "./PrerequisitesForPractical";
import FlightProficiencyPractical from "./FlightProficiencyPractical";
import AeronauticalKnowledgeTwo from "./AeronauticalKnowledgeTwo";
import ReviewOfDeficienciesTwo from "./ReviewOfDeficienciesTwo";
import PrerequisitesForTest from "./PrerequisitesForTest";
import FlightProficiencyPracticalTwo from "./FlightProficiencyPracticalTwo";
import RetestingForPractical from "./RetestingForPractical";
import CompletionOfFlight from "./CompletionOfFlight";
import ToActAsPilotOne from "./ToActAsPilotOne";
import ToActAsPilotTwo from "./ToActAsPilotTwo";
import ToActAsPilotThree from "./ToActAsPilotThree";
import ToActAsPilotFour from "./ToActAsPilotFour";
import ToActAsPilotFive from "./ToActAsPilotFive";
import ToActAsPilotSix from "./ToActAsPilotSix";

const templates = [
  {
    templateId: 0,
    getTemplate: (templateName) => (
      <CustomEndorsement templateName={templateName} />
    ),
  },
  {
    templateId: 1,
    getTemplate: (templateName) => <PreSoloOne templateName={templateName} />,
  },
  {
    templateId: 2,
    getTemplate: (templateName) => <PreSoloTwo templateName={templateName} />,
  },
  {
    templateId: 3,
    getTemplate: (templateName) => <PreSoloThree templateName={templateName} />,
  },
  {
    templateId: 4,
    getTemplate: (templateName) => (
      <SoloFlightOne templateName={templateName} />
    ),
  },
  {
    templateId: 5,
    getTemplate: (templateName) => (
      <SoloFlightTwo templateName={templateName} />
    ),
  },
  {
    templateId: 6,
    getTemplate: (templateName) => (
      <SoloFlightThree templateName={templateName} />
    ),
  },
  {
    templateId: 7,
    getTemplate: (templateName) => (
      <SoloFlightFour templateName={templateName} />
    ),
  },
  {
    templateId: 8,
    getTemplate: (templateName) => (
      <SoloFlightFive templateName={templateName} />
    ),
  },
  {
    templateId: 9,
    getTemplate: (templateName) => (
      <EndorsementOfUs templateName={templateName} />
    ),
  },
  {
    templateId: 10,
    getTemplate: (templateName) => (
      <SoloCrossCountryOne templateName={templateName} />
    ),
  },
  {
    templateId: 11,
    getTemplate: (templateName) => (
      <RepeatedSoloCrossCountry templateName={templateName} />
    ),
  },
  {
    templateId: 12,
    getTemplate: (templateName) => (
      <SoloCrossCountryTwo templateName={templateName} />
    ),
  },
  {
    templateId: 13,
    getTemplate: (templateName) => (
      <AeronauticalKnowledge templateName={templateName} />
    ),
  },
  {
    templateId: 14,
    getTemplate: (templateName) => (
      <ReviewOfDeficiencies templateName={templateName} />
    ),
  },
  {
    templateId: 15,
    getTemplate: (templateName) => (
      <PrerequisitesForPractical templateName={templateName} />
    ),
  },
  {
    templateId: 16,
    getTemplate: (templateName) => (
      <FlightProficiencyPractical templateName={templateName} />
    ),
  },
  {
    templateId: 17,
    getTemplate: (templateName) => (
      <AeronauticalKnowledgeTwo templateName={templateName} />
    ),
  },
  {
    templateId: 18,
    getTemplate: (templateName) => (
      <ReviewOfDeficienciesTwo templateName={templateName} />
    ),
  },
  {
    templateId: 19,
    getTemplate: (templateName) => (
      <PrerequisitesForTest templateName={templateName} />
    ),
  },
  {
    templateId: 20,
    getTemplate: (templateName) => (
      <FlightProficiencyPracticalTwo templateName={templateName} />
    ),
  },
  {
    templateId: 21,
    getTemplate: (templateName) => (
      <RetestingForPractical templateName={templateName} />
    ),
  },
  {
    templateId: 22,
    getTemplate: (templateName) => (
      <CompletionOfFlight templateName={templateName} />
    ),
  },
  {
    templateId: 23,
    getTemplate: (templateName) => (
      <ToActAsPilotOne templateName={templateName} />
    ),
  },
  {
    templateId: 24,
    getTemplate: (templateName) => (
      <ToActAsPilotTwo templateName={templateName} />
    ),
  },
  {
    templateId: 25,
    getTemplate: (templateName) => (
      <ToActAsPilotThree templateName={templateName} />
    ),
  },
  {
    templateId: 26,
    getTemplate: (templateName) => (
      <ToActAsPilotFour templateName={templateName} />
    ),
  },
  {
    templateId: 27,
    getTemplate: (templateName) => (
      <ToActAsPilotFive templateName={templateName} />
    ),
  },
  {
    templateId: 28,
    getTemplate: (templateName) => (
      <ToActAsPilotSix templateName={templateName} />
    ),
  },
];

export default templates;
